<template>
  <div>
    <component :is="currentStepComponent" @change-step="handleStepChanging" />
  </div>
</template>

<script>
  import InfoRegister from '@/containers/auth/register/InfoRegister';
  import CodeRegister from '@/containers/auth/register/CodeRegister';
  import CompanyDetailsRegister from '@/containers/auth/register/CompanyDetailsRegister';
  import ChooseCompany from '@/containers/auth/register/ChooseCompany';

  export default {
    name: 'Register',
    components: {
      InfoRegister,
      CodeRegister,
      ChooseCompany,
      CompanyDetailsRegister,
    },
    model: {
      prop: 'currentStep',
      event: 'next-step',
    },
    props: {
      currentStep: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        registerSteps: {
          1: InfoRegister,
          2: CodeRegister,
          3: ChooseCompany,
          3.1: CompanyDetailsRegister,
        },
      };
    },
    computed: {
      currentStepComponent() {
        return this.registerSteps[this.currentStep];
      },
    },
    methods: {
      handleStepChanging(step) {
        this.$emit('next-step', step);
      },
    },
  };
</script>
